import EventBus from './lib/EventBus.js';
import { track, trackCubeCustomEvent } from '../components/tracking/trackingLayer.js';

export const previewDifferentColor = (articleId) => {
  EventBus.emit('ents:vue:color:preview', articleId);
};

export const releasePreviewDifferentColor = () => {
  EventBus.emit('ents:vue:color:preview', null);
};

export const trackColorChange = (data) => {
  trackCubeCustomEvent('color_selection_used', {
    event_category: 'color_selection',
    is_interaction_event: true,
    event_type: 'click',
  });
  if (data !== undefined) {
    track(data);
  }
};

export const observeAndTrackColorSelectionContainer = (elementToObserve, colors, syan) => {
  let tracked = false;

  const trackListSeen = (elements, colors) => {
    if (!elements || elements.length === 0 || !colors || tracked) {
      return;
    }
    const element = elements[0];
    if (!element.isIntersecting) {
      return;
    }
    trackCubeCustomEvent(
      'color_selection_view',
      {
        event_category: 'color_selection',
        is_interaction_event: false,
        event_type: 'view',
      },
      colors.map((color) => ({
        farb_id: color.articleNumber,
        is_available: !color.outOfStock,
        syan,
      })),
    );
    tracked = true;
  };

  const observer = new IntersectionObserver(
    (entries) => {
      trackListSeen(entries, colors);
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: [0, 1],
    },
  );
  observer.observe(elementToObserve);

  const stop = () => {
    observer.disconnect();
  };

  return {
    observer,
    stop,
  };
};
